import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "803ff32f-75ea-40c3-9fbe-134fa1d903a8", content: "Increasing the detection sphere", options: {} },
  { id: "463de148-dd52-47ad-a8de-fe217036d90f", content: "Changing the scattering coefficients", options: {} },
  { id: "c5c9df4f-b930-4acd-b70d-cb357ef3166c", content: "Moving the sound source", options: {} },
  { id: "2522d7ba-da11-4fef-abce-53975d033ee2", content: "Decreasing the  particle count", options: {} },
  { id: "a0f00f8f-8e39-4be6-8072-69a792134b70", content: "Enlarging the room", options: {} },
];

const groups = [
  { id: "d1ccfa1b-b306-423e-afed-31758a293e76", content: "stochastic error decreases", options: {} },
  { id: "416f058c-4afb-47ba-adba-28de41fdbae9", content: "stochastic error decreases", options: {} },
  { id: "f138e6cd-59a4-4077-bb2e-e597c5d7d76c", content: "stochastic error increases", options: {} },
];

export const task: Task = {
  id: "0383f2f5-e437-4d07-bc60-19aa6dae237a",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "d1ccfa1b-b306-423e-afed-31758a293e76",
      itemsId: ["803ff32f-75ea-40c3-9fbe-134fa1d903a8"],
    },
    {
      groupId: "416f058c-4afb-47ba-adba-28de41fdbae9",
      itemsId: ["463de148-dd52-47ad-a8de-fe217036d90f", "c5c9df4f-b930-4acd-b70d-cb357ef3166c"],
    },
    {
      groupId: "f138e6cd-59a4-4077-bb2e-e597c5d7d76c",
      itemsId: ["2522d7ba-da11-4fef-abce-53975d033ee2", "a0f00f8f-8e39-4be6-8072-69a792134b70"],
    },
  ],
};
